export default function Reducer(state, action) {
  switch (action.type) {
    case 'LOAD':
      return {
        ...state,
        policyPlans: action.policyPlans,
      };  
    default:
      throw Error(`Unknown action: ${action.type}`);
  }
}
